import { Box, Typography } from '@mui/material';

interface DividerWithTitleProps {
  title: string;
}

export default function DividerWithTitle({ title }: DividerWithTitleProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography fontSize={'11px'} color={'primary.main'} mb={0.5}>
        {title}
      </Typography>
      <Box
        sx={{
          height: '1px',
          backgroundColor: 'primary.main',
          width: '100%',
        }}
      />
    </Box>
  );
}
